import React, { useState } from "react";
import Modal from "./ui/Modal";
import { X } from "lucide-react"; // Или другой иконки закрытия

interface Category {
  id: number;
  name: string;
  parent_id: string;
  ref_key: string;
  description: string;
  created_at: string;
  updated_at: string;
  children: Category[];
}

interface CategoriesMenuProps {
  categories: Category[];
}

export const MobileCategoriesMenu = ({ categories }: CategoriesMenuProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState<Category | null>(null);
  const [breadcrumbs, setBreadcrumbs] = useState<Category[]>([]);

  const handleCategoryClick = (category: Category) => {
    if (category.children && category.children.length > 0) {
      setSelectedCategory(category);
      setBreadcrumbs([...breadcrumbs, category]);
    } else {
      window.location.href = `/category/${category.ref_key}`;
    }
  };

  const handleBackClick = () => {
    if (breadcrumbs.length > 0) {
      const newBreadcrumbs = [...breadcrumbs];
      newBreadcrumbs.pop();
      setBreadcrumbs(newBreadcrumbs);
      setSelectedCategory(newBreadcrumbs[newBreadcrumbs.length - 1] || null);
    }
  };

  return (
    <>
      {/* Кнопка открытия модального окна */}
      <span 
      className="font-sewmibold text-[12px] tracking-[-2%] leading-[100%]"
        onClick={() => setIsOpen(true)}
      >
        Каталог
      </span>

      {/* Модальное окно категорий */}
      <Modal
        isOpen={isOpen}
        onClose={() => {
          setIsOpen(false);
          setSelectedCategory(null);
          setBreadcrumbs([]);
        }}
        size="xl"
        closeButton={false}
      >
        <div className="flex flex-col h-full">
          {/* Шапка модального окна */}
          <div className="flex items-center justify-between p-4 border-b border-gray-200">
            <button 
              onClick={handleBackClick}
              disabled={breadcrumbs.length === 0}
              className={`p-2 ${breadcrumbs.length === 0 ? 'invisible' : ''}`}
            >
              ←
            </button>
            
            <h2 className="text-lg font-medium">
              {breadcrumbs.length > 0 ? breadcrumbs[breadcrumbs.length - 1]?.name : 'Каталог'}
            </h2>
            
            <button 
              onClick={() => setIsOpen(false)}
              className="p-2"
            >
              <X size={20} />
            </button>
          </div>

          {/* Содержимое модального окна */}
          <div className="flex-1 overflow-y-auto">
            {(selectedCategory ? selectedCategory.children : categories).map((category) => (
              <div
                key={category.ref_key}
                className="px-4 py-3 border-b border-gray-100"
                onClick={() => handleCategoryClick(category)}
              >
                <div className="flex justify-between items-center">
                  <span>{category.name}</span>
                  {category.children && category.children.length > 0 && (
                    <span>→</span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </Modal>
    </>
  );
};